import { mapGetters } from "vuex"
export default{
    data:()=>({

    }),
    
  methods: {
},
computed: {
  ...mapGetters([])
},
}


// WEBPACK FOOTER //
// ./src/pages/Privacy/privacy.js